import { CalendarDays, CheckCircle, Clock, Target } from "lucide-react";

import { Card, CardContent } from "../../../components/ui/card";

const MeetingStats = ({ meetings, onFilterChange }) => {
  const stats = [
    {
      label: "Total Meetings",
      value: meetings.length,
      icon: CalendarDays,
      color: "text-yale-blue-600 dark:text-yale-blue-400",
      bgClass: "bg-yale-blue-50 dark:bg-blue-900/10",
      borderClass: "border-blue-200 dark:border-blue-900/30",
      textClass: "text-yale-blue-600 dark:text-yale-blue-400",
      valueClass: "text-blue-800 dark:text-blue-200",
      filter: "all"
    },
    {
      label: "Upcoming",
      value: meetings.filter((m) => new Date(m.meetingDate) > new Date() && m.status.toLowerCase() === "scheduled").length,
      icon: Clock,
      color: "text-green-600 dark:text-green-400",
      bgClass: "bg-green-50 dark:bg-green-900/10",
      borderClass: "border-green-200 dark:border-green-900/30",
      textClass: "text-green-600 dark:text-green-400",
      valueClass: "text-green-800 dark:text-green-200",
      filter: "upcoming"
    },
    {
      label: "Today",
      value: meetings.filter((m) => new Date(m.meetingDate).toDateString() === new Date().toDateString()).length,
      icon: Target,
      color: "text-orange-600 dark:text-orange-400",
      bgClass: "bg-orange-50 dark:bg-orange-900/10",
      borderClass: "border-orange-200 dark:border-orange-900/30",
      textClass: "text-orange-600 dark:text-orange-400",
      valueClass: "text-orange-800 dark:text-orange-200",
      filter: "today"
    },
    {
      label: "Completed",
      value: meetings.filter((m) => m.status.toLowerCase() === "completed").length,
      icon: CheckCircle,
      color: "text-purple-600 dark:text-purple-400",
      bgClass: "bg-purple-50 dark:bg-purple-900/10",
      borderClass: "border-purple-200 dark:border-purple-900/30",
      textClass: "text-purple-600 dark:text-purple-400",
      valueClass: "text-purple-800 dark:text-purple-200",
      filter: "completed"
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6 mb-6">
      {stats.map((stat) => (
        <Card
          key={stat.label}
          className={`${stat.bgClass} ${stat.borderClass} cursor-pointer hover:shadow-lg transition-all duration-200 hover:scale-[1.02] border shadow-sm`}
          onClick={() => onFilterChange(stat.filter)}
        >
          <CardContent className="p-3 md:p-4">
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <p className={`text-[10px] md:text-xs font-bold uppercase tracking-wider ${stat.textClass} opacity-80 truncate`}>
                  {stat.label}
                </p>
                <p className={`text-xl md:text-2xl font-bold ${stat.valueClass} mt-0.5`}>{stat.value}</p>
              </div>
              <div className={`p-2 rounded-lg bg-white/50 dark:bg-black/20 shrink-0`}>
                <stat.icon className={`h-4 w-4 md:h-5 md:w-5 ${stat.color}`} />
              </div>
            </div>
            <div className={`hidden sm:block mt-2 text-[10px] ${stat.textClass} opacity-60 font-medium`}>Click to filter →</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default MeetingStats;
